import 'react-app-polyfill/ie11';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { BrowserRouter } from 'react-router-dom'
import ScrollToTop from './ScrollToTop';
import { ClientService } from './service/ClientService';

import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from '@azure/msal-react';

import ReactGA from 'react-ga';

(async () => {

    const clientService = new ClientService();
    const client = await clientService.getCurrentClientFromURL();

    if(window.location.href.endsWith("/adlogin")){
        const root = document.documentElement; 
        const customLayout = client.custom_layout;
        if((customLayout.primaryBackgroundColor || "") !== ""){
            root.style.setProperty( "--menuBgColor", customLayout.primaryBackgroundColor); 
            root.style.setProperty( "--topBarBgColor", customLayout.primaryBackgroundColor);    
            root.style.setProperty( "--primaryButtonColor", customLayout.primaryButtonColor);    
        }
    }

    const isAdB2C = clientService.isADB2C(client);

    if(clientService.hasGAConfigured(client)){
        ReactGA.initialize(clientService.getGATrackingId(client))
        ReactGA.pageview(window.location.pathname, null, client.name);
    }
    
    if(isAdB2C)
    {
        const config = clientService.getADB2CConfig(client);
        const msalInstance = new PublicClientApplication(config);

        const hash = window.location.hash;

        if(window.location.href.endsWith("/adlogin")){
            try {
                localStorage.clear();
                sessionStorage.clear();
                msalInstance.loginRedirect();
                return;    
            } catch (error) {
                console.log(error);
            }
        }
        else {

            const AppProvider = () => (
                <MsalProvider instance={msalInstance}>
                    <BrowserRouter>
                        <ScrollToTop>
                            <App client={ client }></App>
                        </ScrollToTop>
                    </BrowserRouter>
                </MsalProvider>
            )

            ReactDOM.render(<AppProvider />, document.getElementById('root'))
        }
    }
    else {
        ReactDOM.render(
            <BrowserRouter>
                <ScrollToTop>
                    <App client={ client }></App>
                </ScrollToTop>
            </BrowserRouter>,
            document.getElementById('root')
        );
    }

})();


